module.exports = __webpack_public_path__ + "img/MultiDays.83b96747.svg";